import {
  createAction,
  joinActions,
  props,
} from "../../helpers/store/actions-helpers";
import { Conversation, Message } from "../interfaces/conversations";

export const setSelectedInstagramConversationAction = createAction(
  "[SocialChat] Select Instagram Conversation",
  props<{ id: number | string | null }>()
);

export const addInstagramMessageAction = createAction(
  "[SocialChat] Set new Instagram Message",
  props<{ message: Message, id: string }>()
);

export const setSelectedFacebookConversationAction = createAction(
  "[SocialChat] Select Facebook Conversation",
  props<{ id: number | string | null }>()
);

export const addFacebookMessageAction = createAction(
  "[SocialChat] Set new Facebook Message",
  props<{ message: Message, id: string }>()
);

export const setSelectedWhatsappConversationAction = createAction(
  "[SocialChat] Select Whatsapp Conversation",
  props<{ id: number | string | null }>()
);

export const addWhatsappMessageAction = createAction(
  "[SocialChat] Set new Whatsapp Message",
  props<{ message: Message, id: string }>()
);

export const addWhatsappConversationAction = createAction(
  "[SocialChat] Set new Whatsapp Conversation",
  props<{ conversation: Conversation }>()
);

const actions = joinActions({
  setSelectedInstagramConversationAction,
  addInstagramMessageAction,
  setSelectedFacebookConversationAction,
  addFacebookMessageAction,
  setSelectedWhatsappConversationAction,
  addWhatsappMessageAction,
  addWhatsappConversationAction,
});

export type SocialChatAction = typeof actions;
